import { memo, useState, useEffect, useRef } from "react";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Grid2, Button, FormControl, FormLabel, TextField, Typography, Select, FormControlLabel, Stack, Checkbox, MenuItem } from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useCommonStyles } from '../../styles/GenericStyle';
import ScanInput from '../ScanInput';
import { gray83, lightGray, red, greyDark } from "../../colors";
import CropFreeIcon from '@mui/icons-material/CropFree';
import { MtComStyleObj } from '../../styles/MtComStyleObj';
import type { MaterialGridModel, AddEditMaterial } from '../../api/vegApl/SPLotModel';
import { MessageConstant } from '../../utils/MessageConst';
import { useGlobalState } from "../../contexts/GlobalState";
import { useAddMaterial, useEditMaterial, useCheckMatidExistMutation } from '../../api/vegApl';
import { useSnackbar } from '../../contexts/SnackbarContext';
import { useConfirm } from "../../contexts/confirmDialogContext";
import { toTitleCase,numericOnlyKeyDown } from "../../utils/HelperFunction";
import { GenericConstant } from '../../utils/GenericConstant';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { useDropdownPosition } from '../../hooks/useDropdownPosition';
import FullScreenActionLoader from '../common/FullScreenActionLoader';
// import {
//     ALL_MATERIAL_FIELDS_MANDATORY,
//     // getMaterialDefaultValuesByCrop,
//     // getMaterialMandatoryMapByCrop,
//     // type MaterialMandatoryMap,
// } from '../../utils/materialMandatoryFields';

export type SPLotDialogprops = {
    mode: string,
    openAddEditMatModal: boolean,
    setaddEditMatModal?: (open: boolean) => void,
    materialRowData?: MaterialGridModel | null,
    drillDownCurrRow?: any
    setRefreshMatGrid?: (isRefresh: boolean) => void,

}

function AddEditSPLotFormDialog({ mode, openAddEditMatModal, setaddEditMatModal, materialRowData, drillDownCurrRow, setRefreshMatGrid }: SPLotDialogprops) {
    const classes = useCommonStyles();
    const { remarks, priorities: prioritArr, state: globalState, state } = useGlobalState();
    const [scannedValue, setScannedValue] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    // Button-only spinner for the pre-save check; isLoading would also show the full-screen loader.
    const [isValidating, setIsValidating] = useState(false);
    // const [mandatoryFields, setMandatoryFields] = useState<MaterialMandatoryMap>(ALL_MATERIAL_FIELDS_MANDATORY);
    // const [isApplyingFieldRules, setIsApplyingFieldRules] = useState(false);
    // Read synchronously right after validation completes, so it is never a stale render value.
    const confirmThresholdRef = useRef(false);
    const validatedMatIdRef = useRef("");
    const isSubmittingRef = useRef(false);
    const { showSnackbar } = useSnackbar();
    const { confirm } = useConfirm();
    const weightFieldRef = useRef<HTMLInputElement>(null);
    const materialIdFieldRef = useRef<HTMLInputElement>(null);
    const { menuPosition, calculatePosition } = useDropdownPosition(300);
    // const { refetch: refetchCrops } = useGetRefCrops(drillDownCurrRow?.site_code, {
    //     query: {
    //         enabled: false,
    //         refetchOnReconnect: false,
    //         refetchOnWindowFocus: false,
    //         refetchOnMount: false,
    //     },
    // });
    const { mutateAsync: checkMatidExistMutation } = useCheckMatidExistMutation();

    const { roleSelected = "" } = state;
    const {
        control, register, handleSubmit, reset, getValues, setValue, /* watch, */
        formState: { errors },
    } = useForm<AddEditMaterial>({
        defaultValues: { weight: '', fruit_count: "", bag_number: "1", remark_id: "", priority: "", material_harvest_id: "", addMultipleMaterial: true },
        mode: "onChange"
    });

    // const watchedWeight = String(watch('weight') ?? '').trim();
    // const watchedFruitCount = String(watch('fruit_count') ?? '').trim();
    // const watchedBagNumber = String(watch('bag_number') ?? '').trim();
    // const watchedRemarkId = String(watch('remark_id') ?? '').trim();

    const isSaveDisabled =
        isLoading ||
        (mode === "Add" && !scannedValue.trim());
        // (mandatoryFields.weight && !watchedWeight) ||
        // (mandatoryFields.fruit_count && !watchedFruitCount) ||
        // (mandatoryFields.bag_number && !watchedBagNumber);

    // const applyMaterialFieldRules = async (cropFilter?: string | { cropCode?: string | null; cropName?: string | null }) => {
    //     setIsApplyingFieldRules(true);
    //     try {
    //         const response = await refetchCrops();
    //         const crops = (response?.data?.data ?? []) as any[];
    //         // const nextMandatoryMap = getMaterialMandatoryMapByCrop(crops, cropFilter);
    //         // const defaultValues = getMaterialDefaultValuesByCrop(crops, cropFilter);

    //         // setMandatoryFields(nextMandatoryMap);

    //         // Auto-populate fruit weight, fruit count, and bags from defaults
    //         // if (!String(getValues('weight') ?? '').trim() && defaultValues.weight !== undefined) {
    //         //     setValue('weight', String(defaultValues.weight));
    //         // }
    //         // if (!String(getValues('fruit_count') ?? '').trim() && defaultValues.fruit_count !== undefined) {
    //         //     setValue('fruit_count', String(defaultValues.fruit_count));
    //         // }
    //         // if (!String(getValues('bag_number') ?? '').trim() && defaultValues.bag_number !== undefined) {
    //         //     setValue('bag_number', String(defaultValues.bag_number));
    //         // }
    //     } catch {
    //         // setMandatoryFields(ALL_MATERIAL_FIELDS_MANDATORY);
    //     } finally {
    //         setIsApplyingFieldRules(false);
    //     }
    // };

    const resolvedCropCode = drillDownCurrRow?.crop_code ?? drillDownCurrRow?.crop ?? "";
    //const resolvedCropName = drillDownCurrRow?.crop_name ?? drillDownCurrRow?.cropName ?? "";

    const stopSearchFlowAndResetMaterialId = () => {
        confirmThresholdRef.current = false;
        validatedMatIdRef.current = "";
        setScannedValue("");
        setTimeout(() => {
            materialIdFieldRef.current?.focus();
        }, 100);
    };

    const handleSearchMaterial = async (matId?: string): Promise<boolean> => {
        const materialId = matId || scannedValue.trim();
        if (materialId) {
            try {
                const response = await checkMatidExistMutation({ data: { matid: materialId, splot_id: drillDownCurrRow?.splot_id, crop_code: resolvedCropCode, site_code: drillDownCurrRow?.site_code } });
                const data: any = response?.data;
                if (data && (Array.isArray(data) ? data.length > 0 : data)) {
                    // Check for threshold warning before populating form
                    if (data.warning === GenericConstant.THRESHOLDREACHED) {
                        const userConfirmed: any = await confirm({
                            title: "Threshold Warning",
                            description: data.message,
                            confirmText: "Yes",
                            cancelText: "No",
                            severity: "warning",
                        });
                        if (!userConfirmed) {
                            stopSearchFlowAndResetMaterialId();
                            return false;
                        }
                        confirmThresholdRef.current = true;
                    } else {
                        confirmThresholdRef.current = false;
                    }
                    // Populate priority & remark from response if available
                    // if (data.remark) {
                    //     const matchedRemark = remarks.find((r: any) => r.remark_name === data.remark);
                    //     if (matchedRemark) setValue('remark_id', String(matchedRemark.remark_id));
                    // }
                    if (data.priority) {
                        const matchedPriority = prioritArr.find((p: any) => p.value === data.priority);
                        if (matchedPriority) setValue('priority', String(matchedPriority.id));
                    }
                    if (data.material_harvest_id) {
                        setValue('material_harvest_id', data.material_harvest_id);
                    }
                    if (data.material_harvest_id) {
                        setValue('material_harvest_id', data.material_harvest_id);
                    }
                    // await applyMaterialFieldRules({ cropCode: resolvedCropCode, cropName: resolvedCropName });
                    validatedMatIdRef.current = materialId;
                    weightFieldRef.current?.focus();
                    return true;
                } else {
                    stopSearchFlowAndResetMaterialId();
                    showSnackbar({ message: 'Material not found', severity: 'error' });
                    return false;
                }
            } catch (error: any) {
                const detail = error?.response?.data?.detail;
                console.log(detail);
                stopSearchFlowAndResetMaterialId();
                showSnackbar({ message: detail || 'Material not found', severity: 'error' });
                return false;
            }
        } else {
            stopSearchFlowAndResetMaterialId();
            showSnackbar({ message: 'Material ID is required', severity: 'warning' });
            return false;
        }
    };

    const saveCheckboxPreferenceAndClose = () => {
        confirmThresholdRef.current = false;
        validatedMatIdRef.current = "";
        setaddEditMatModal && setaddEditMatModal(false);
    };

    const onSubmit = async (data: any) => {
        // Blocks a second Save while the check/threshold dialog is still pending. Not isLoading,
        // because that also drives the full-screen loader, which would cover the dialog.
        if (isSubmittingRef.current) return;
        isSubmittingRef.current = true;
        setIsValidating(true);
        try {
            // Saving without pressing Scan must still run the mat-id-exists / threshold check.
            if (mode == "Add") {
                const matId = scannedValue.trim();
                if (validatedMatIdRef.current !== matId) {
                    const isValid = await handleSearchMaterial(matId);
                    if (!isValid) return;
                    // The check populates these via setValue, which the pre-await snapshot misses.
                    data.priority = getValues('priority');
                    data.material_harvest_id = getValues('material_harvest_id');
                }
            }

            data.user_id = globalState?.user_id_db;
            data.splot_id = drillDownCurrRow?.splot_id;
            data.mat_id = mode == "Add" ? scannedValue.trim() : materialRowData?.material_id;
            data.weight = Number(data.weight)?.toFixed(1);
            data.remark_id = !data.remark_id ? 0 : data.remark_id;
            data.priority = data.priority ?? "";
            data.crop_code = resolvedCropCode;
            data.site_code = drillDownCurrRow?.site_code ?? "";

            delete data['addMultipleMaterial'];
            for (const key in data) {
                if (key == "bag_number" || key == "fruit_count" || key == "weight") {
                    data[key] = Number(data[key])
                }
            }
            if (confirmThresholdRef.current) {
                data.confirm_threshold = true;
            } else {
                data.confirm_threshold = false;
            }
            setIsLoading(true);
            mode == "Add" ? addEditMaterial({ data: data }) : editMaterial({ data: data });
        } finally {
            isSubmittingRef.current = false;
            setIsValidating(false);
        }
    };
    const { mutate: addEditMaterial } = useAddMaterial({
        mutation: {
            onSuccess: (data: any) => {
                setIsLoading(false);
                if (data?.data?.error) {
                    showSnackbar({ message: data?.data?.error, severity: 'error' });
                }
                else {
                    showSnackbar({ message: data?.data?.message, severity: 'success' });
                    if (getValues("addMultipleMaterial") == true) {
                        reset({ weight: '', fruit_count: '', bag_number: '1', remark_id: '', priority: '', material_harvest_id: '', addMultipleMaterial: true });
                        setScannedValue("");
                        setFocusOnMaterialField();
                    }
                    else {
                        setaddEditMatModal && setaddEditMatModal(false);
                        setRefreshMatGrid && setRefreshMatGrid(true);
                        setFocusOnMaterialField();
                    }
                }
            },
            onError: (error: any) => {
                const detail = error?.response?.data?.detail;
                const errorMessage = typeof detail === 'string' ? detail : 'Error in adding Material';
                showSnackbar({ message: errorMessage, severity: 'error' });
                setIsLoading(false)
            },
        },
    });

    const { mutate: editMaterial } = useEditMaterial({
        mutation: {
            onSuccess: (data: any) => {
                showSnackbar({ message: data?.data?.message, severity: 'success' });
                setaddEditMatModal && setaddEditMatModal(false);
                setRefreshMatGrid && setRefreshMatGrid(true);
                setIsLoading(false)
            },
            onError: (error: any) => {
                const detail = error?.response?.data?.detail;
                const errorMessage = typeof detail === 'string' ? detail : 'Error in updating Material';
                showSnackbar({ message: errorMessage, severity: 'error' });
                setIsLoading(false)

            },
        },
    })

    useEffect(() => {
        if (!openAddEditMatModal) {
            reset({
                weight: '',
                fruit_count: '',
                bag_number: '1',
                remark_id: '',
                priority: '',
                material_harvest_id: '',
                addMultipleMaterial: true
            });
            materialRowData = null;
            setScannedValue("");
            // setMandatoryFields(ALL_MATERIAL_FIELDS_MANDATORY);
            confirmThresholdRef.current = false;
            validatedMatIdRef.current = "";
        } else {
            let remark_id =
                remarks.find(
                    r => r.remark_name === materialRowData?.remarks?.trim()
                )?.remark_id;



            reset({
                weight: materialRowData?.fruit_weight_g,
                fruit_count: materialRowData?.fruit_count,
                bag_number: materialRowData?.bags ?? '1',
                remark_id: remark_id?.toString(),
                priority: materialRowData?.priority,
                material_harvest_id: materialRowData?.material_harvest_id ?? '',
                addMultipleMaterial: true
            });
            if (mode === "Add") {
                setFocusOnMaterialField();
            }
        }
    }, [openAddEditMatModal, materialRowData, mode]);

    const setFocusOnMaterialField = () => {
        setTimeout(() => {
            materialIdFieldRef.current?.focus();
        }, 100);
    }

    const handleItemClick = (item: any, type: string) => {
        if (getValues(type as keyof AddEditMaterial) == item) {
            setValue(type as keyof AddEditMaterial, "");
        }
    }

    return (
        <>
            <FullScreenActionLoader open={isLoading} />
            <Dialog open={openAddEditMatModal} slotProps={{
                paper: {
                    sx: {
                        borderRadius: "16px",
                    },
                },
            }} sx={(theme) => ({
                ...MtComStyleObj(theme).dialogBoxStyle
            })}>
                <DialogTitle sx={{ pt: 1, pb: 0 }}>
                    <Box display={"flex"} justifyContent={"space-between"}>
                        <div>
                            <Typography component="div" className={classes.labelNoto14500}>
                                {mode == "Add" ? "Add New Material" : `Edit Material `}
                            </Typography>
                            <Typography component="div" className={classes.labelNoto16Bold400}>
                                SP Lot : {drillDownCurrRow?.splot_id}
                            </Typography>
                        </div>
                        <IconButton aria-label="close" onClick={() => { saveCheckboxPreferenceAndClose(); setRefreshMatGrid && setRefreshMatGrid(true); }}
                            sx={(theme) => ({ ...MtComStyleObj(theme).dialogCloseButton })}><CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>

                <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate>
                    <DialogContent sx={{ mt: 2, pb: 1 }}>
                        <Grid2 container spacing={2} sx={mode === "Edit"
                            ? { backgroundColor: lightGray, p: 2 } : {}}>
                            {mode == "Edit" ? <> <Grid2 size={{ xs: 12, sm: 5, md: 5 }}>
                                <Stack direction="column" spacing={2}>
                                    <Box>
                                        <Typography className={classes.labelInter16Bold400} sx={{ color: gray83 }}>Material ID</Typography>
                                        <Typography className={classes.labelInter16}>{materialRowData?.material_id ?? ""}</Typography>
                                    </Box>
                                    <Box>
                                        <Typography className={classes.labelInter16Bold400} sx={{ color: gray83 }}>Trial ID</Typography>
                                        <Typography className={classes.labelInter16}>{materialRowData?.trial_id ?? ""}</Typography>
                                    </Box>
                                </Stack>
                            </Grid2>
                                <Grid2 size={{ xs: 12, sm: 5, md: 5 }}>
                                    <Stack direction="column" spacing={2}>
                                        <Box>
                                            <Typography className={classes.labelInter16Bold400} sx={{ color: gray83 }}>Pollination ID</Typography>
                                            <Typography className={classes.labelInter16}>{materialRowData?.pollination_id ?? ""}</Typography>
                                        </Box>
                                        <Box>
                                            <Typography className={classes.labelInter16Bold400} sx={{ color: gray83 }}>Status</Typography>
                                            <Typography className={classes.labelInter16}>{toTitleCase(materialRowData?.material_status)}</Typography>
                                        </Box>
                                    </Stack>
                                </Grid2></> :
                                <>
                                    <Grid2 size={{ xs: 12, sm: 6, md: 12 }}>
                                        <FormControl size="small" fullWidth>
                                            <FormLabel sx={{ color: greyDark }} className={classes.labelInter14Bold400}>Material ID<span style={{ color: red, marginLeft: 4 }}>*</span></FormLabel>
                                            <Stack direction="row" spacing={1} sx={{ width: "100%", mt: 1 }}>
                                                <ScanInput
                                                    ref={materialIdFieldRef}
                                                    submitOnScan
                                                    scanPickupEnabled={true}
                                                    defaultValue={scannedValue}
                                                    onScan={(val) => setScannedValue(val)}
                                                    onChange={(val) => setScannedValue(val)}
                                                    manualEdit={true}
                                                    label="Material ID"
                                                    placeholder="Scan or Enter Material ID"
                                                    errorText="Scanner should work without clicking on text field"
                                                    onEnterPress={handleSearchMaterial}
                                                />
                                                <Button
                                                    variant="contained" disableRipple
                                                    className={classes.greenButton}
                                                    startIcon={<CropFreeIcon />}
                                                    sx={() => ({
                                                        p: 2,
                                                    })}
                                                    onClick={() => handleSearchMaterial()}
                                                >
                                                    {'Scan'}
                                                </Button>
                                            </Stack>
                                        </FormControl>
                                    </Grid2>
                                </>}
                        </Grid2>
                        <Grid2 container spacing={2} sx={{ mt: 1.5 }}>
                            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
                                <FormControl size="small" fullWidth>
                                    <FormLabel sx={{ color: greyDark }} className={classes.labelInter14Bold400}>Fruit Weight (g)</FormLabel>
                                    <TextField placeholder="0.0" type="number"
                                        onKeyDown={numericOnlyKeyDown}
                                        sx={(theme) => ({
                                            mt: 0.5,
                                            ...MtComStyleObj(theme).textFocusHoverStyle,
                                            ...MtComStyleObj(theme).textBoxValueStyle,
                                        })} inputRef={weightFieldRef} {...register('weight', {
                                            validate: (value) => {
                                                const parsedValue = String(value ?? '').trim();

                                                // if (mandatoryFields.weight && !parsedValue) {
                                                //     return MessageConstant.WEIGHTREQ;
                                                // }

                                                if (parsedValue && Number(parsedValue) < 0) {
                                                    return MessageConstant.VALUECANNTNEGATIVE;
                                                }

                                                if (parsedValue && Number(parsedValue) > 10000) {
                                                    return 'Maximum allowed is 10000';
                                                }

                                                return true;
                                            }
                                        })} error={!!errors.weight} helperText={errors.weight?.message} slotProps={{ htmlInput: { max: 10000 }, formHelperText: { sx: { ml: 0 } } }} />
                                </FormControl>
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
                                <FormControl size="small" fullWidth>
                                    <FormLabel sx={{ color: greyDark }} className={classes.labelInter14Bold400}>Fruit Count</FormLabel>
                                    <TextField placeholder="0" type="number"
                                       onKeyDown={numericOnlyKeyDown}
                                        sx={(theme) => ({
                                            mt: 0.5,
                                            ...MtComStyleObj(theme).textFocusHoverStyle
                                        })} {...register('fruit_count', {
                                            validate: (value) => {
                                                const parsedValue = String(value ?? '').trim();

                                                // if (mandatoryFields.fruit_count && !parsedValue) {
                                                //     return MessageConstant.FRUITCOUNTREQ;
                                                // }

                                                if (parsedValue && Number(parsedValue) < 0) {
                                                    return MessageConstant.VALUECANNTNEGATIVE;
                                                }

                                                if (parsedValue && Number(parsedValue) > 1000) {
                                                    return 'Maximum allowed is 1000';
                                                }

                                                return true;
                                            }
                                        })} error={!!errors.fruit_count} helperText={errors.fruit_count?.message} slotProps={{ htmlInput: { max: 1000 }, formHelperText: { sx: { ml: 0 } } }} />
                                </FormControl>
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 4, md: 4 }}>
                                <FormControl size="small" fullWidth>
                                    <FormLabel sx={{ color: greyDark }} className={classes.labelInter14Bold400}>Bags</FormLabel>
                                    <TextField type="number" placeholder="0"
                                       onKeyDown={numericOnlyKeyDown}
                                        sx={(theme) => ({
                                            mt: 0.5,
                                            ...MtComStyleObj(theme).textFocusHoverStyle,
                                            ...MtComStyleObj(theme).textBoxValueStyle,
                                        })} {...register('bag_number', {
                                            validate: (value) => {
                                                const parsedValue = String(value ?? '').trim();

                                                // if (mandatoryFields.bag_number && !parsedValue) {
                                                //     return MessageConstant.BAGSREQ;
                                                // }

                                                if (parsedValue && Number(parsedValue) < 0) {
                                                    return MessageConstant.VALUECANNTNEGATIVE;
                                                }

                                                if (parsedValue && Number(parsedValue) > 1000) {
                                                    return 'Maximum allowed is 1000';
                                                }

                                                return true;
                                            },
                                        })} error={!!errors.bag_number} helperText={errors.bag_number?.message} slotProps={{ htmlInput: { max: 1000 }, formHelperText: { sx: { ml: 0 } } }} />
                                </FormControl>
                            </Grid2>
                        </Grid2>
                        <Grid2 container spacing={2} sx={{ mt: 2 }}>
                            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                                <FormControl size="small" fullWidth>
                                    <FormLabel sx={{ color: greyDark, '&.Mui-focused': { color: greyDark } }} className={classes.labelInter14Bold400}>Remarks</FormLabel>
                                    <Controller name="remark_id" control={control}
                                        render={({ field }) => (
                                            <Select
                                                IconComponent={KeyboardArrowDownOutlinedIcon}
                                                sx={(theme) => ({
                                                    height: 40, mt: 0.5,
                                                    ...MtComStyleObj(theme).fieldFocusHoverStyle,
                                                    "& .MuiSelect-icon": {
                                                        fontSize: 25,
                                                        color: '#000000'
                                                    },

                                                })}
                                                displayEmpty
                                                disabled={mode === "Edit" && !["S2S-Lead", "Admin"].includes(roleSelected)}
                                                onOpen={calculatePosition}
                                                renderValue={(selected) => {
                                                    return selected ? <Typography component="span" sx={{ ...GenericConstant.DROPDOWNSTYLE }}>
                                                        {remarks.find((ele: any) => ele?.remark_id == selected)?.remark_name}
                                                    </Typography> : <Typography component="span" className={classes.labelNoto16Bold400} color="#808080">Add Remark</Typography>
                                                }}

                                                {...field} value={field.value || ""} MenuProps={{
                                                    anchorOrigin: menuPosition.anchorOrigin,
                                                    transformOrigin: menuPosition.transformOrigin,
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300,
                                                            marginTop: menuPosition.anchorOrigin.vertical === "top" ? -8 : 8
                                                        }
                                                    }
                                                }}>

                                                {remarks?.map((remarks, index) => (
                                                    <MenuItem disableRipple sx={{ ...GenericConstant.DROPDOWNSTYLE }}

                                                        key={'remarks' + index} value={remarks?.remark_id ?? ""} onClick={() => handleItemClick(remarks?.remark_id ?? "", "remark_id")}>{remarks?.remark_name}</MenuItem>
                                                ))}
                                            </Select>
                                        )} />
                                </FormControl>
                            </Grid2>
                            <Grid2 size={{ xs: 12, sm: 6, md: 6 }} >
                                <FormControl size="small" fullWidth>
                                    <FormLabel sx={{ color: greyDark, '&.Mui-focused': { color: greyDark } }} className={classes.labelInter14Bold400}>Processing Priority</FormLabel>
                                    <Controller name="priority" control={control}
                                        render={({ field }) => (
                                            <Select sx={(theme) => ({
                                                height: 40, mt: 0.5,
                                                ...MtComStyleObj(theme).fieldFocusHoverStyle,
                                                "&.MuiSelect-icon": {
                                                    fontSize: 25,
                                                    color: '#000000'
                                                },
                                            })}
                                                displayEmpty
                                                disabled={mode === "Edit" && !["Breeder", "Admin"].includes(roleSelected)}
                                                onOpen={calculatePosition}
                                                renderValue={(selected) => {
                                                    return selected ? <Typography component="span" sx={{ ...GenericConstant.DROPDOWNSTYLE }}>
                                                        {prioritArr.find((ele: any) => ele?.id == selected)?.value}
                                                    </Typography> : <Typography component="span" className={classes.labelNoto16Bold400} color="#808080">Choose Processing Priority</Typography>
                                                }}

                                                {...field} value={field.value || ""} MenuProps={{
                                                    anchorOrigin: menuPosition.anchorOrigin,
                                                    transformOrigin: menuPosition.transformOrigin,
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 300,
                                                            marginTop: menuPosition.anchorOrigin.vertical === "top" ? -8 : 8
                                                        }
                                                    }
                                                }}>

                                                {prioritArr?.map((priority: any) => (
                                                    <MenuItem disableRipple sx={{ ...GenericConstant.DROPDOWNSTYLE }} key={'priority' + priority?.id} value={priority?.id ?? ""} onClick={() => handleItemClick(priority?.id ?? "", "priority")}>{priority?.value}</MenuItem>
                                                ))}
                                            </Select>
                                        )} />
                                </FormControl>
                            </Grid2>
                            {mode == "Add" && <FormControl size="small">
                                <Controller
                                    name="addMultipleMaterial"
                                    control={control}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            label="Add Multiple Materials"
                                            sx={(theme) => ({
                                                '& .MuiFormControlLabel-label': {
                                                    ...MtComStyleObj(theme).labelNoto16400
                                                },
                                            })}

                                            control={
                                                <Checkbox
                                                    size="small" {...field} name={field.name} checked={!!field.value}
                                                    sx={GenericConstant.CHECKBOXSTYLE}
                                                    checkedIcon={<Box component="img" alt="" src={"icons/CheckBox.svg"} />}
                                                    onChange={(_e, checked) => {
                                                        field.onChange(checked);
                                                    }}
                                                />
                                            }
                                        />
                                    )}
                                />
                            </FormControl>
                            }
                        </Grid2>
                    </DialogContent>
                    <DialogActions sx={{ mt: mode === "Edit" ? 2 : 0 }}>
                        {mode == "Edit" && <Button variant="contained" disableRipple sx={{ padding: "10px 12px" }}
                            onClick={() => { saveCheckboxPreferenceAndClose() }} className={classes.whiteButton}>Cancel</Button>}
                        <Button type="submit" variant="contained" disableRipple loading={isLoading || isValidating} loadingPosition="start" className={classes.greenButton}
                            sx={{ padding: "10px 12px" }}
                            disabled={isSaveDisabled}
                            onClick={() => {
                                if (scannedValue == "" && mode == "Add") {
                                    showSnackbar({ message: 'Material ID is required. Scan a Material ID to proceed.', severity: 'warning' });
                                }
                            }}>{mode == "Edit" ? "Save Changes" : "Save"}</Button>
                    </DialogActions>
                </Box>
            </Dialog >
        </>
    );
}
export default memo(AddEditSPLotFormDialog);
